<!-- <div class="my-2 pb-1 user-activity-request-box">
    @if(activity?.kudosRequest?.show){
        <button class="btn user-activity-request-btn" data-cy="user-activity-request-kudos-open" 
                (click)="createKudos()" #createKudosButton>
        <i class="fa-light fa-hands-holding-heart pe-2"></i>{{'kudos.new' | translate}} 
        </button>
    }
    <button class="btn user-activity-request-btn" data-cy="user-activity-request-question" 
            (click)="createQuestion()">
            <i class="fa-regular fa-message-question pe-2"></i>{{'topic.question.new' | translate}} 
    </button>
    <button class="btn user-activity-request-btn" 
            (click)="createIssue()">
            <i class="fa-regular fa-message-exclamation pe-2"></i>{{'topic.issue.new' | translate}} 
    </button>
</div> -->

<div class="alert border p-3 mt-3">
    <h4 class="position-relative" (click)="showFullActivityBox = !showFullActivityBox">
        {{'user_activity' | translate}}
        @if(!showFullActivityBox || !showActivitySpinner){
            <i class="fa-solid fa-chevron-down position-absolute end-0 top-0"></i>
        }@else{
            <i class="fa-solid fa-chevron-up position-absolute end-0 top-0"></i>
        }
    </h4>
    @if(!showFullActivityBox){
        <div (click)="showFullActivityBox = !showFullActivityBox">
            <div>{{'user_activity.description' | translate}}</div>
        </div>
    }
    @if(showActivitySpinner){
        <div class="text-center text-primary">
            <div><i class="far fa-spinner fa-spin pt-1 pb-2"></i></div>
        </div>
    }

    @if(showFullActivityBox){
        <div>
    <!--    Activity: contributions     -->
            @if(activity?.commentYourMood?.length === 1 || activity?.popularComments?.length>0){
                <div class="mb-4">
                    <h5>{{'user_activity.contributions' | translate}}</h5>
                    @if(activity?.commentYourMood?.length === 1){
                        <div class="user-activity-item mb-4">
                            <p>
                                <i class="fa-light fa-pen pe-1"></i><i>{{'user_activity.contributions.comment' | translate}}</i>
                            </p>
                            <button class="btn btn-sm user-activity-btn" 
                                    (click)="addCommentToYourMoodAction(activity.commentYourMood[0].timelineItemId)">
                                    {{'user_activity.contributions.comment_cta' | translate}}
                            </button>
                        </div>
                    }

                    @if(activity?.popularComments?.length>0){
                        <div class="user-activity-item">
                            <i class="fa-light fa-ranking-star pe-1"></i>
                            @if(activity?.popularComments?.length === 1){
                                <i>{{activity.popularComments.length}} {{'user_activity.contributions.popular' | translate}}</i>
                            }
                            @if(activity?.popularComments?.length > 1){
                                <i>{{activity.popularComments.length}} {{'user_activity.contributions.popular_plural' | translate}}</i>
                            }
                            <ul>
                                @for(comment of activity?.popularComments; track comment){
                                    <li>
                                        <button class="text-secondary topic-title" (click)="scrollTo(comment.timelineItemId)"
                                                [matTooltip]="comment.comment" matTooltipPosition="right">
                                            "<span>{{comment.commentWithFormattedLinks}}</span>"<i class="fa-light fa-square-arrow-up-right ps-1"></i>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>
                    } 
                </div>
            }
            
            @if(activity?.activeBadMoodStreaks?.length > 0 || activity?.activeTopics?.length > 0 || activity?.activeKudos?.length > 0){
                <div>
                    <h5>{{'user_activity.highlights' | translate}}</h5>
                    @if(activity?.activeBadMoodStreaks?.length>0){
                        <div class="user-activity-item mb-4">
                            @if(activity?.activeBadMoodStreaks?.length === 1){
                                <i>{{activity.activeBadMoodStreaks.length}} {{'user_activity.highlights.streaks' | translate}}</i>
                            }
                            @if(activity?.activeBadMoodStreaks?.length > 1){
                                <i>{{activity.activeBadMoodStreaks.length}} {{'user_activity.highlights.streaks_plural' | translate}}</i>
                            }
                            <ul>
                                @for(streak of activity?.activeBadMoodStreaks; track streak){
                                    <li>
                                        <button class="text-secondary topic-title" (click)="scrollTo(streak.timelineItemId)">
                                                {{'user_activity.highlights.streak_details' | translate}} {{ streak.dateAsString }} <i class="fa-light fa-square-arrow-up-right ps-1"></i>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                    
                    @if(activity?.activeTopics?.length>0){
                        <div class="user-activity-item">
                            @if(activity?.activeTopics?.length === 1){
                                <i>{{activity.activeTopics.length}} {{'user_activity.highlights.topics' | translate}}</i>
                            }
                            @if(activity?.activeTopics?.length > 1){
                                <i>{{activity.activeTopics.length}} {{'user_activity.highlights.topics_plural' | translate}}</i>
                            }
                            <ul>
                                @for(topic of activity?.activeTopics; track topic){
                                    <li>
                                        <button class="text-secondary topic-title" (click)="scrollTo(topic.timelineItemId)"
                                                [matTooltip]="topic.title" matTooltipPosition="right">
                                            "<span>{{topic.titleWithFormattedLinks}}</span>"
                                            <span><i class="fa-light fa-square-arrow-up-right ps-1"></i></span>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                    
                    @if(activity?.activeKudos?.length>0){
                        <div class="user-activity-item" [ngPlural]="activity.activeKudos.length">
                            <ng-template ngPluralCase="=1">
                                <i>{{activity?.activeKudos.length}} {{'user_activity.highlights.kudos' | translate}}</i>
                            </ng-template>
                            <ng-template ngPluralCase="other">
                                <i>{{activity?.activeKudos.length}} {{'user_activity.highlights.kudos_plural' | translate}}</i>
                            </ng-template>
                            <ul>
                                @for(kudos of activity?.activeKudos; track kudos){
                                    <li>
                                        <button class="text-secondary topic-title" (click)="scrollTo(kudos.timelineItemId)"
                                                [matTooltip]="kudos.title" matTooltipPosition="right">
                                            "<span>{{kudos.titleWithFormattedLinks}}</span>"
                                            <span><i class="fa-light fa-square-arrow-up-right ps-1"></i></span>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                </div>
            }
            
    
            @if(activity?.popularComments?.length === 0 || activity?.commentYourMood?.length === 0 || activity?.activeBadMoodStreaks?.length === 0 || activity?.activeTopics?.length === 0 || activity?.activeKudos?.length === 0){
                <div>
                    <h5>{{'user_activity.contributions' | translate}}</h5>
                    @if(activity?.topicRequest?.show){
                        <div class="user-activity-item mb-4">
                            <p>
                                <i class="fa-light fa-messages pe-1"></i><i>{{'user_activity.contributions.topic' | translate}}</i>
                            </p>
                            <button class="btn btn-sm user-activity-btn" (click)="createQuestion()">{{'topic.start' | translate}} </button>
                        </div>  
                    }
                    @if(activity?.kudosRequest?.show){
                        <div class="user-activity-item mb-4">
                            <p>
                                <i class="fa-light fa-messages pe-1"></i><i>{{'user_activity.contributions.kudos' | translate}}</i>
                            </p>
                            <button class="btn btn-sm user-activity-btn" (click)="createKudos()">{{'kudos.start' | translate}} </button>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>   


